import { cn } from "@lib/utils";
import RoadmapCompleteImg from "../assets/RoadmapComplete.png";
import RoadmapCurrentImg from "../assets/RoadmapCurrent.png";
import RoadmapLockedImg from "../assets/RoadmapLocked.png";

type RoadmapStatus = "complete" | "current" | "locked" | "unsuccessful";

interface RoadmapCardProps {
  status: RoadmapStatus;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

const statusStyles: Record<RoadmapStatus, string> = {
  complete: "bg-[#EBF6F0]",
  current: "bg-[#F8E7C6]",
  locked: "bg-[#F7F7F7] text-[#678175]",
  unsuccessful: "bg-[#FFDCD8]",
};

const statusImages: Record<RoadmapStatus, string> = {
  complete: RoadmapCompleteImg,
  current: RoadmapCurrentImg,
  locked: RoadmapLockedImg,
  unsuccessful: RoadmapLockedImg,
};

const statusImgSize: Record<RoadmapStatus, string> = {
  complete: "w-6 h-[22.5px]",
  current: "w-6 h-[33px]",
  locked: "w-6 h-[33px]",
  unsuccessful: "w-[22.3px] h-[22.3px]",
};

export default function RoadmapCard({ status, title, subtitle, children }: RoadmapCardProps) {
  return (
    <div className={cn("rounded-lg flex min-h-[86px] p-4 items-center gap-6", statusStyles[status])}>
      <img
        src={statusImages[status]}
        alt={`${status} step indicator`}
        className={statusImgSize[status]}
      />
      <div className="flex flex-col">
        <p className="font-semibold bodyLarger">{title}</p>
        {subtitle && <p>{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
